import { BrandLocation } from 'src/constans/branding';

export const getBrandByLocation = (location?: string | null) => {
  switch ((location || '').toLowerCase()) {
    case BrandLocation.GEORGETOWN:
      return {
        key: BrandLocation.GEORGETOWN,
        label: 'Georgetown logo placeholder',
      };
    case BrandLocation.RUTGERS:
      return {
        key: BrandLocation.RUTGERS,
        label: 'Rutgers logo placeholder',
      };
    default:
      return {
        key: 'default',
        label: 'ENGAGE logo placeholder',
      };
  }
};
